import { DialogTitle } from '@mui/material';
import { memo } from 'react';
import CommentForm from 'src/forms/Comment/CommentForm';
import DuelForm from 'src/forms/Duel/DuelForm';
import ExchangeForm from 'src/forms/Exchange/ExchangeForm';
import FeedItemForm from 'src/forms/FeedItem/FeedItemForm';
import GameForm from 'src/forms/Game/GameForm';
import GameEntryFeeRewardsForm from 'src/forms/GameEntryFeeRewards/GameEntryFeeRewardsForm';
import GameFeeForm from 'src/forms/GameFee/GameFeeForm';
import GameJoinForm from 'src/forms/GameJoin/GameJoinForm';
import GamePlayListForm from 'src/forms/GamePlayList/GamePlaylistForm';
import GatewayForm from 'src/forms/Gateway/GatewayForm';
import GatewayJoinProfileForm from 'src/forms/GatewayJoinProfile/GatewayJoinProfileForm';
import GatewayProfileForm from 'src/forms/GatewayProfile/GatewayProfileForm';
import LandingPageForm from 'src/forms/LandingPage/LandingPageForm';
import MediaGroupForm from 'src/forms/MediaGroup/MediaGroupForm';
import MediaSocialPlayerForm from 'src/forms/MediaSocialPlayer/MediaSocialPlayerForm';
import NotificationBannerForm from 'src/forms/NotificationBanner/NotificationBannerForm';
import RtmpForm from 'src/forms/Rtmp/RtmpForm';
import RtmpAppForm from 'src/forms/RtmpApp/RtmpAppForm';
import SocialManagerAccountForm from 'src/forms/SocialManager/Accounts/SocialManagerAccountsForm';
import SocialManagerChannelForm from 'src/forms/SocialManager/channel/SocialManagerChannelsForm';
import SocialManagerContentForm from 'src/forms/SocialManager/content/SocialManagerContentForm';
import SubscribePackageForm from 'src/forms/SubscribePackage/SubscribePackageForm';
import TransactionPackageForm from 'src/forms/TransactionPackage/TransctionPackageForm';
import WheelForm from 'src/forms/Wheel/WheelForm';
import WheelItemForm from 'src/forms/WheelItem/WheelItemForm';
import AppSectionForm from 'src/forms/appSection/AppSectionForm';
import AppVerstionControlForm from 'src/forms/appVersionControl/AppVerstionControlForm';
import AvatarForm from 'src/forms/avatar/AvatarForm';
import GameCardForm from 'src/forms/footballop/GameCardForm/GameCardForm';
import ProfileRewardForm from 'src/forms/profileReward/ProfileRewardForm';
import UserEdit from 'src/pages/dashboard/UserEdit';
import WikiMediaForm from 'src/sections/@dashboard/content-hub/list/WikiMediaForm';
import useFormsModalStore from 'src/store/forms';
import HostForm from 'src/forms/Host/HostForm';
import SubIMenuItemForm from 'src/forms/MenuSubItem/SubIMenuItemForm';
import GiftCodeGenerate from 'src/forms/SubscribePackage/GiftCodeGenerate';
import GiftCodeIndex from 'src/forms/SubscribePackage/GiftCodeIndex';
import SubscribePackagePositionForm from 'src/forms/SubscribePackagePosition/SubscribePackagePositionForm';
import SubscribePackageTypeForm from 'src/forms/SubscribePackageType/SubscribePackageTypeForm';
import UploadToServerForm from 'src/forms/UploadToServer/UploadToServerForm';
import DomianForm from 'src/forms/domain/domainForm';
import TransactionAmountTypeForm from 'src/forms/TransactionAmountType/TransactionAmountTypeForm';
import NotificationStyleForm from 'src/forms/NotificationStyle/NotificationStyleForm';
import NotificationPopupForm from 'src/forms/NotificationPopup/NotificationPopupForm';
import GamePreviewForm from 'src/forms/Game/GamePreviewForm';
import GameWikiForm from 'src/forms/Game/GameWikiForm';

import { DialogAnimate } from '../animate';

import {
  APP_BANNER_LIST,
  APP_DUAL_LIST,
  APP_SECTION_LIST,
  APP_VERSION_CONTROL_LIST,
  AVATAR_LIST,
  COMMENT_LIST,
  DOMAIN_FORM,
  FEED_ITEM_LIST,
  FOOTBALLOP_GAME_CARD_LIST,
  GAME_ENTRY_FEE_LIST,
  GAME_ENTRY_FEE_REWARD,
  GAME_JOIN_LIST,
  GAME_JOIN_PLAYLIST_LIST,
  GAME_LIST,
  GATEWAY_JOIN_PROFILE_LIST,
  GATEWAY_LIST,
  GATEWAY_PROFILE_LIST,
  HOST_FORM,
  LANDING_PAGE_LIST,
  MEDIA_GROUP_PLAYLIST,
  MEDIA_SOCIAL_PLAYER_LIST,
  NOTIFICATION_STYLE_LIST,
  NOTIFICATION_POPUP_LIST,
  PROFILE_REWARD__LIST,
  PRODUCT_TYPE,
  RTMP_LIST,
  RTMP_LIST_VOD,
  SOCIAL_MANAGER_ACCOUNT_LIST,
  SOCIAL_MANAGER_CHANNEL_LIST,
  SOCIAL_MANAGER_CONTENT_LIST,
  SUBMENU_ITEM,
  SUBSCRIBE_GIFT_GENERATE,
  SUBSCRIBE_GIFT_LIST,
  SUBSCRIBE_PACKAGE_LIST,
  SUBSCRIBE_PACKAGE_POSITION_LIST,
  SUBSCRIBE_PACKAGE_TYPE_LIST,
  TRANSACTION_AMOUNT_TYPE_LIST,
  TRANSACTION_EXCHANGE_CONFIG_LIST,
  TRANSACTION_PACKAGE_LIST,
  UPLOAD_TO_SERVER_LIST,
  USER_LIST,
  WHEEL_ITEM_LIST,
  WHEEL_LIST,
  WIKI_MEDIA_LIST,
  GAME_PREVIEW_LIST,
  GAME_Wiki_LIST,
  ADD_NEW_GAME_ARTIST,
  MEDIA_COOPERATION_LIST,
  MEDIA_COOPERATION_SCRIPT,
  APP_MEDIA_REWARDS_LIST,
} from 'src/constants/queryKeys';
import GameArtistForm from 'src/forms/Game/GameArtistForm';
import MediaCooperationForm from 'src/forms/MediaCooperation/MediaCooperationForm';
import { MediaCooperationForms } from 'src/pages/dashboard/MediaCooperation';
import MediaCooperationScriptForm from 'src/forms/MediaCooperationScript/MediaCooperationScriptForm';
import ProductTypeForm from 'src/forms/productType';
import MediaRewardsForm from 'src/forms/MediaRewards/MediaRewardsForm';

const GeneralFormsModal = memo(() => {
  const { modal, closeModal } = useFormsModalStore();

  const formsType = {
    [MEDIA_GROUP_PLAYLIST]: <MediaGroupForm />,
    [LANDING_PAGE_LIST]: <LandingPageForm />,
    [WHEEL_LIST]: <WheelForm />,
    [WHEEL_ITEM_LIST]: <WheelItemForm />,
    [TRANSACTION_PACKAGE_LIST]: <TransactionPackageForm />,
    [GAME_ENTRY_FEE_LIST]: <GameFeeForm />,
    [RTMP_LIST_VOD]: <RtmpForm />,
    [RTMP_LIST]: <RtmpAppForm />,
    [APP_DUAL_LIST]: <DuelForm />,
    [APP_BANNER_LIST]: <NotificationBannerForm />,
    [APP_SECTION_LIST]: <AppSectionForm />,
    [USER_LIST]: <UserEdit />,
    [GAME_JOIN_LIST]: <GameJoinForm />,
    [GAME_JOIN_PLAYLIST_LIST]: <GamePlayListForm />,
    [FEED_ITEM_LIST]: <FeedItemForm />,
    [GATEWAY_LIST]: <GatewayForm />,
    [GATEWAY_PROFILE_LIST]: <GatewayProfileForm />,
    [GATEWAY_JOIN_PROFILE_LIST]: <GatewayJoinProfileForm />,
    [FOOTBALLOP_GAME_CARD_LIST]: <GameCardForm />,
    [SOCIAL_MANAGER_ACCOUNT_LIST]: <SocialManagerAccountForm />,
    [SOCIAL_MANAGER_CHANNEL_LIST]: <SocialManagerChannelForm />,
    [SOCIAL_MANAGER_CONTENT_LIST]: <SocialManagerContentForm />,
    [GAME_LIST]: <GameForm />,
    [TRANSACTION_EXCHANGE_CONFIG_LIST]: <ExchangeForm />,
    [APP_VERSION_CONTROL_LIST]: <AppVerstionControlForm />,
    [GAME_ENTRY_FEE_REWARD]: <GameEntryFeeRewardsForm />,
    [AVATAR_LIST]: <AvatarForm />,
    [MEDIA_SOCIAL_PLAYER_LIST]: <MediaSocialPlayerForm />,
    [COMMENT_LIST]: <CommentForm />,
    [PROFILE_REWARD__LIST]: <ProfileRewardForm />,
    [PRODUCT_TYPE]: <ProductTypeForm />,
    [WIKI_MEDIA_LIST]: <WikiMediaForm />,
    [SUBSCRIBE_PACKAGE_LIST]: <SubscribePackageForm />,
    [SUBSCRIBE_GIFT_LIST]: <GiftCodeIndex />,
    [SUBSCRIBE_GIFT_GENERATE]: <GiftCodeGenerate />,
    [UPLOAD_TO_SERVER_LIST]: <UploadToServerForm />,
    [SUBSCRIBE_PACKAGE_TYPE_LIST]: <SubscribePackageTypeForm />,
    [SUBSCRIBE_PACKAGE_POSITION_LIST]: <SubscribePackagePositionForm />,
    [DOMAIN_FORM]: <DomianForm />,
    [HOST_FORM]: <HostForm />,
    [SUBMENU_ITEM]: <SubIMenuItemForm />,
    [TRANSACTION_AMOUNT_TYPE_LIST]: <TransactionAmountTypeForm />,
    [NOTIFICATION_STYLE_LIST]: <NotificationStyleForm />,
    [NOTIFICATION_POPUP_LIST]: <NotificationPopupForm />,
    // GAEM HUB
    [GAME_PREVIEW_LIST]: <GamePreviewForm />,
    [GAME_Wiki_LIST]: <GameWikiForm />,
    [ADD_NEW_GAME_ARTIST]: <GameArtistForm />,

    [MEDIA_COOPERATION_LIST]: <MediaCooperationForms />,
    [MEDIA_COOPERATION_SCRIPT]: <MediaCooperationScriptForm />,
    [APP_MEDIA_REWARDS_LIST]: <MediaRewardsForm />,
  };

  if (!modal.isOpen) return null;

  return (
    <DialogAnimate
      open={modal.isOpen}
      onClose={closeModal}
      maxWidth={modal?.size || 'lg'}
      sx={{ paddingX: { md: '32px' }, paddingY: { md: '24px' } }}
    >
      <DialogTitle sx={{ py: '8px' }}>{modal.title}</DialogTitle>
      {formsType[modal.type] || <p className="text-lg text-center">فرم موجود نیست</p>}
    </DialogAnimate>
  );
});

export default GeneralFormsModal;
